<template>

  <!-- Modal close -->
  <div
    class="w-full h-screen bg-transparent absolute top-0 left-0 right-0 z-40 cursor-default"
    v-show="(recipientsModal || attachmentModal || deleteModal2 || detailModal)"
    @click="recipientsModal = false, attachmentModal = false, deleteModal2 = false, detailModal = false">
  </div>

  <!-- RECIPIENTS -->
  <vue-final-modal
    v-model="recipientsModal"
    classes="flex justify-center items-center"
    :ssr="true"
    content-class="relative h-5/6 flex flex-col mx-4 md:mx-0 pt-2 pb-4 border dark:border-gray-600 rounded bg-white dark:bg-gray-900 w-11/12 md:w-4/5 lg:w-1/2"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t','tr','r','br','b','bl','l','tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <jb-button
        class="absolute top-1 right-1 z-20 rounded-lg  dark:bg-gray-800 dark:text-white dark:border-gray-700"
        @click="recipientsModal = false"
        :icon="mdiClose">
    </jb-button>
    <div class="grow overflow-y-auto">
      <recipients-form
        :prop-comboards="comboards"
        :prop-child="recipientsObject"
        @close-modal="hideModal4">
      </recipients-form>
    </div>
  </vue-final-modal>

  <!-- ATTACHMENT -->
  <vue-final-modal
    v-model="attachmentModal"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'add-modal add-modal bg-darkmode-base transition-colors duration-1000' : 'add-modal add-modal bg-white transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1 v-if="showEditAtt">{{ $t('attachment.edit') }}</h1>
      <h1 v-else>{{ $t('attachment.form') }}</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="attachmentModal = false" />
    </div>

    <!-- Modal content -->
    <div class="modal-content">
      <attachment-form
      :prop-comboards="comboards"
      :show-edit="showEditAtt"
      :prop-attach="attachObject"
      @close-modal="hideModal2"
      @click-refresh-from="refreshHeader"
      />
    </div>
  </vue-final-modal>

  <!-- DELETE ATTACHMENT -->
  <vue-final-modal
    v-model="deleteModal2"
    classes="base-modal"
    :ssr="true"
    :content-class="darkMode ? 'delete-modal bg-darkmode-base transition-colors duration-1000' : 'delete-modal bg-gray-100 transition-colors duration-1000'"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false"
    transition="vfm"
    overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false"
    drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>{{ $t('menu.delete') }} {{ $t('menu.data') }}</h1>

      <jb-button class="btn-close-modal" :icon="mdiClose" @click="deleteModal2 = false" />
    </div>

    <!-- Modal content -->
    <div class="delete-content">
      <div class="warning">{{ $t('menu.warning') }}</div>

      <div class="messsage"><p>{{ $t('confirmDelete.message') }}</p></div>
    </div>

    <!-- Button action -->
    <div class="buttons-submit transition-colors duration-1000" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
      <jb-buttons class="buttons-action-submit">
        <jb-button :label="$t('finance.button.btnConfirm')" color="info" :icon="mdiTrashCan" @click="confirm2" class="form-submit-btn" />
        <jb-button :label="$t('finance.button.btnCancel')" outline @click="deleteModal2 = false" class="btn-reset form-noicon-btn" />
      </jb-buttons>
    </div>
  </vue-final-modal>

  <!-- DETAIL ATTACHMENT -->
  <vue-final-modal
    v-model="detailModal"
    classes="base-modal"
    :ssr="true"
    content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="250"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <!-- Modal header -->
    <div class="modal-head">
      <h1>{{ $t('attachment.detail') }}</h1>

      <jb-button
        class="btn-close-modal"
        :icon="mdiClose"
        @click="detailModal = false" />
    </div>

    <div class="modal-content detail-content">
      <attachment-detail
        :prop-attach="attachObject"
        @close-modal="hideModalDetail">
      </attachment-detail>
    </div>
  </vue-final-modal>

  <!-- Modal Replace View -->
  <vue-final-modal v-model="detailReplaceView" classes="flex justify-center items-center"
      content-class="relative w-full h-5/6 flex flex-col mx-4 md:mx-0 pt-2 pb-4 border dark:border-gray-600   bg-white dark:bg-gray-900 w-full md:w-4/5 lg:w-2/3"
      :ssr="true"
      :lock-scroll="true"
      :hide-overlay="false"
      :click-to-close="true"
      :esc-to-close="true"
      :prevent-click="true"
      :attach="false" transition="vfm" overlay-transition="vfm"
      :z-index-auto="true"
      :z-index-base="1000"
      :z-index="false"
      :focus-retain="true"
      :focus-trap="false"
      :fit-parent="true"
      :drag="false" drag-selector=""
      :keep-changed-style="false"
      :resize="false"
      :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
      :min-width="800"
      :min-height="250"
      :max-width="Infinity"
      :max-height="Infinity"
      >
      <jb-button class="absolute top-1 right-1 z-20 rounded-lg  dark:bg-gray-800 dark:text-white dark:border-gray-700" :icon="mdiClose" @click="detailReplaceView = false" />

      <div class="space-y-3 pb-3 pl-4 z-10 shadow-lg dark:shadow-gray-200">
          <h1 class="text-2xl">Preview</h1>
          <slot />
      </div>
      <div class="grow overflow-y-auto">
          <!-- <h2 class="pl-7 font-semibold mt-5">
              {{ previewpdf.file_name }}
          </h2> -->
          <div v-if="uploadFile.base64 != ''">
              <vue-pdf-embed class="mt-2" :source="uploadFile.base64" v-if="uploadFile.type == 'pdf'" />

              <img class="image pl-4 mt-2" :src="uploadFile.base64" :alt="uploadFile.type" v-else>
          </div>
      </div>
  </vue-final-modal>

  <!-- Modal Replace -->
  <vue-final-modal v-model="replaceModalView" classes="flex justify-center items-center"
    content-class="relative h-auto max-h-5/6 flex flex-col mx-4 md:mx-0 pt-2 pb-4 border dark:border-gray-800   bg-white dark:bg-gray-900 w-full md:w-1/2 lg:w-1/3"
    :ssr="true"
    :lock-scroll="true"
    :hide-overlay="false"
    :click-to-close="true"
    :esc-to-close="true"
    :prevent-click="true"
    :attach="false" transition="vfm" overlay-transition="vfm"
    :z-index-auto="true"
    :z-index-base="1000"
    :z-index="false"
    :focus-retain="true"
    :focus-trap="false"
    :fit-parent="true"
    :drag="false" drag-selector=""
    :keep-changed-style="false"
    :resize="false"
    :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
    :min-width="800"
    :min-height="250"
    :max-width="Infinity"
    :max-height="Infinity"
  >
    <jb-button class="absolute top-1 right-1 z-20 rounded-lg  dark:bg-gray-800 dark:text-white dark:border-gray-700" :icon="mdiClose" @click="replaceModalView = false" />

    <div class="space-y-3 pb-3 pl-4 z-10 shadow-lg dark:shadow-gray-200">
        <h1 class="text-2xl">Information</h1>
        <slot />
    </div>
    <form @submit.prevent="false" class="w-full mx-auto h-full p-4">
        <div class="grow overflow-y-auto">
            <div class="flex flex-wrap mb-6">
                <field label="File is already exist! Create another version or replace existing file?" class="w-full form-select">
                    <input
                        type="file"
                        accept="image/*, application/pdf"
                        v-on:change="onFileChange"
                        class="form-control-file"
                        id="my-file-comboard-replace"
                        />
                </field>
            </div>
            <jb-buttons class="flex flex-nowrap justify-start w-full gap-3">
                <jb-button type="button" color="info" :icon="mdiCheckBold" label="Create" class="form-submit-btn" @click="saveUpload('create')" />
                <jb-button type="button" color="warning" :icon="mdiReload" label="Replace" class="form-submit-btn" @click="saveUpload('replace')" />
                <jb-button type="button" color="success" :icon="mdiFileEyeOutline" label="View" class="form-submit-btn" @click="viewUpload()" />
            </jb-buttons>
        </div>
    </form>
  </vue-final-modal>
  <!-- End -->

  <div class="transition-colors duration-1000 w-full" :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'">
    <ul class="flex justify-center items-center">
      <div v-for="(tab, index) in tabs" :key="index" :class="{ 'is-active': activeTab === index }">
        <li class="cursor-pointer py-2 px-4 text-gray-500 border-b-8" :class="activeTab===tab.index ? 'text-green-500 border-green-500' : ''" @click="$event => activeTab = tab.index" v-text="tab.name"></li>
      </div>
    </ul>
  </div>

  <div v-show="activeTab===0" class="w-full">
    <card-component
      class="relative mb-2 px-2 md:px-4 bg-white border border-gray-100 dark:bg-gray-900 dark:border-gray-600"
      :title="'Recipients'"
      :icon="mdiBookshelf"
      has-table
    >
      <jb-button
        class="add-btn rounded-xl py-1 px-5 shadow-lg mt-1 w-auto absolute right-4 top-1 hidden md:flex"
        :label="'Add'"
        color="info"
        :icon="mdiPlusCircleOutline"
        small
        @click="addRecipients()"
      />
    <dl>
      <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6" style="border-top: 1.25px solid rgba(0, 0, 0, 0.125)">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.titlecomboard') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.title }}
          </dd>
      </div>
      <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.show_date') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.show_date }}
          </dd>
      </div>
      <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('Is Priority') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.is_priority === true ? 'Yes' : 'No' }}
          </dd>
      </div>
      <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.category') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.category_name }}
          </dd>
      </div>
      <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.info') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          <span style="font-size: 14px !important;" v-html="comboards.info"></span>
          </dd>
      </div>
      <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.is_event') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2" v-if="comboards.is_event === true">
            {{ 'Yes' }}
          </dd>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2" v-else>
            {{ 'No' }}
          </dd>
      </div>
      <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.start_event') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.datetime_1 }}
          </dd>
      </div>
      <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.end_event') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.datetime_2 }}
          </dd>
      </div>
      <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.to_parent') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2" v-if="comboards.to_parent === true">
            {{ 'Yes' }}
          </dd>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2" v-else>
            {{ 'No' }}
          </dd>
      </div>
      <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.to_student') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2" v-if="comboards.to_student === true">
            {{ 'Yes' }}
          </dd>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2" v-else>
            {{ 'No' }}
          </dd>
      </div>
      <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.to_teacher') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2" v-if="comboards.to_teacher === true">
            {{ 'Yes' }}
          </dd>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2" v-else>
            {{ 'No' }}
          </dd>
      </div>
      <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.add_calendar') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2" v-if="comboards.add_to_calendar === true">
            {{ 'Yes' }}
          </dd>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2" v-else>
            {{ 'No' }}
          </dd>
      </div>
      <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.recalled') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2" v-if="comboards.is_recalled === true">
            {{ 'Yes' }}
          </dd>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2" v-else>
            {{ 'No' }}
          </dd>
      </div>
      <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.recall_time') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.recall_time }}
          </dd>
      </div>
      <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.reason') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.reason }}
          </dd>
      </div>

      <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
            {{ $t('comboard.link') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.link_url }}
          </dd>
      </div>

      <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
          {{ $t('class.createdAt') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.created_at }}
          </dd>
      </div>

      <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
          {{ $t('class.createdBy') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.created_by }}
          </dd>
      </div>

      <div class="bg-white dark:bg-gray-700 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
        <dt class="text-base font-medium text-gray-500 dark:text-white">
          {{ $t('class.updatedAt') }}
        </dt>
        <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.updated_at }}
        </dd>

      </div>
      <div class="bg-gray-50 dark:bg-gray-800 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
          <dt class="text-base font-medium text-gray-500 dark:text-white">
          {{ $t('class.updatedBy') }}
          </dt>
          <dd class="mt-1 text-sm text-gray-900 dark:text-gray-400 sm:mt-0 sm:col-span-2">
          {{ comboards.updated_by }}
          </dd>
      </div>
    </dl>
  </card-component>
  </div>

  <div v-show="activeTab===1" class="w-full px-4">
    <card-component
      class="relative mb-2 px-2 md:px-4 bg-white border border-gray-100 dark:bg-gray-900 dark:border-gray-600"
      :title="'Attachment'"
      :icon="mdiBookshelf"
      has-table
    >
      <jb-button
        class="add-btn rounded-xl py-1 px-5 shadow-lg mt-1 w-auto absolute right-4 top-1 hidden md:flex"
        :label="'Add'"
        color="info"
        :icon="mdiPlusCircleOutline"
        small
        @click="addAttachment()"
      />
      <ag-grid-vue
        style="width: 100%; height: 70vh;"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :pagination="true"
        v-text-v-html="keyData"
        :context="context"
        @grid-ready="onGridReady"
        :rowData="rowData.value">
      </ag-grid-vue>
    </card-component>

    <div v-if="slides == 0"></div>
    <div v-else>
      <!-- <carousel
        :key="0"
        :slides="slides"
        :interval="3000"
        controls
        indicators>
      </carousel> -->
    </div>
  </div>

  <div class="flex gap-4 justify-center border-t p-4">
    <button class="
      py-2
      px-4
      border
      rounded-md
      border-blue-600
      text-blue-600
      cursor-pointer
      uppercase
      text-sm
      font-bold
      hover:bg-blue-500 hover:text-white hover:shadow"
      @click="activeTab--" v-if="activeTab > 0">
      Back
    </button>
    <button class="
        py-2
        px-4
        border
        rounded-md
        border-blue-600
        text-blue-600
        cursor-pointer
        uppercase
        text-sm
        font-bold
        hover:bg-blue-500 hover:text-white hover:shadow"
        @click="activeTab++" v-if="activeTab < tabs.length - 1">
        Next
    </button>
  </div>

  <div class="vld-parent">
    <loading
      v-model:active="isLoading"
      :is-full-page="true"
      :height="128"
      :width="128"/>
  </div>

</template>
<script>
 /* eslint-disable */
import axios from 'axios'
import { axiosDocument } from '@/boot/axios'
import Field from '@/components/Field'
import { useToast } from 'vue-toastification'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import CardComponent from '@/components/CardComponent'
// import MainSection from '@/components/MainSection'
import { AgGridVue } from 'ag-grid-vue3'
import AttachmentDetail from '@/views/comboards/attachment/AttachmentDetail.vue'
import RecipientsForm from '@/views/comboards/comboard/RecipientsForm.vue'
import AttachmentForm from '@/views/comboards/attachment/AttachmentForm.vue'
// import Carousel from '@/views/comboards/comboard/Carousel.vue'
import JbButton from '@/components/JbButton'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import ButtonActionComboardAttachment from '@/components/ButtonActionComboardAttachment'
import {
  mdiClose,
  mdiCircleMedium,
  mdiMenuDown,
  mdiCheckBold,
  mdiReload,
  mdiFileEyeOutline,
  mdiSend,
  mdiTrashCan,
  mdiPlusCircleOutline,
  mdiBallot,
  mdiBookshelf
} from '@mdi/js'
import {
    ref,
    reactive,
    watchEffect,
    onBeforeMount,
    onMounted,
    watch
} from 'vue'
export default {
  name: 'ComboardForm',
  components: {
    CardComponent,
    Field,
  // MainSection,
    AgGridVue,
    AttachmentForm,
    RecipientsForm,
    AttachmentDetail,
    // Carousel,
    Loading,
    JbButton,
  // eslint-disable-next-line
    ButtonActionComboardAttachment
  },

  props: {
      comment: Object,
      showEdit: { Boolean },
      propClass: {
          type: Object,
          default: () => ({ empty: true })
      }
  },

  data: function () { return {} },

  emits: ['close-modal', 'click-refresh', 'submit'],
  setup (props, { emit }) {
    const { t } = useI18n()
    const isLoading = ref(false)
    const childModal = ref(false)
    const attachmentModal = ref(false)
    const showEditAtt = ref(false)
    const attachObject = ref()
    const recipientsModal = ref(false)
    const recipientsObject = ref()
    const detailModal = ref(false)
    const rowData = reactive([])
    const slides = reactive([])
    const idValue = ref()
    const idValueAttach = ref()
    const errors = ref([])
    const toast = useToast()
    const str = useStore()
    const router = useRouter()
    const userlogin = localStorage.getItem('name')
    const titleStack = ref(['Admin', 'Forms'])
    const deleteModal = ref(false)
    const deleteModal2 = ref(false)
    const childObject = ref({})
    const activeTab = ref(0)
    // COMMENT
    const hideModal = () => {
      deleteModal.value = false
      refresh()
    }
    const showModal = () => {
      deleteModal.value = !deleteModal.value
    }
    const comboardsdetailId = ref()
    const deleteComboard = (value) => {
      showModal()
      comboardsdetailId.value = value
    }

    // ATTACHMENT
    const hideModalDetail = () => {
      detailModal.value = false
    }
    const hideModal2 = () => {
      attachmentModal.value = false
      refresh2()
    }
    const refreshHeader = () => {
      refresh()
      refresh2()
      emit('click-refresh')
    }
    const showModal2 = () => {
      attachmentModal.value = !attachmentModal.value
    }
    const detailData = (event, attach) => {
      detailModal.value = true
      attachObject.value = attach
    }
    const editData = (event, attach) => {
      // edit ATT COMBOARD tanpa doc
      attachObject.value = attach
      showEditAtt.value = true
      showModal2()

      //  edit ATT COMBOARD dengan doc
      // replaceDataView(attach)
      // // replaceModalView.value = true
      // // uploadFile.id_file = env
    }

    const attachmentAdd = reactive({
      id: '',
      file_1: '',
      comboard_id: ''
    })
    const addAttachment = (value) => {
      showEditAtt.value = false

      attachmentAdd.comboard_id = idValue.value
      attachObject.value = attachmentAdd
      showModal2()
    }
    const attachId = ref()
    const deleteModalShow = (value) => {
      deleteModal2.value = true
      attachId.value = value
    }
    // CHILD COMMENT
    const showModal3 = () => {
      childModal.value = !childModal.value
    }
    const addChild = (item) => {
      showModal3()
      childObject.value = item
    }
    const hideModal3 = () => {
      childModal.value = false
    }
    // RECIPIENTS
    const showModal4 = () => {
      recipientsModal.value = !recipientsModal.value
    }
    const addRecipients = () => {
      showModal4()
      recipientsObject.value = comboards
    }
    const hideModal4 = () => {
      recipientsModal.value = false
    }

    const confirmDel = () => confirmDelete()
    const confirm2 = () => confirmDelete2()
    const cancel = () => (deleteModal.value = false)
    const cancel2 = () => (deleteModal2.value = false)
    const confirmDelete = () => {
      isLoading.value = true
      axios
      .delete(`comboard-detail/${comboardsdetailId.value}`)
      .then(response => {
        if (response.data.success) {
          refresh()
          hideModal()
          isLoading.value = false
          toast.success(response.data.message, {
            timeout: 5000
          })
        } else {
          isLoading.value = false
          toast.error(response.data.message, { timeout: 5000 })
        }
        }).catch(error => {
          isLoading.value = false
          console.log(error)
      })
    }

    const deleteDocComboard = (env) => {
      axiosDocument
      .delete(`delete-comboard/${env}`)
      .then(response => {
      }).catch(error => {
        console.log('error', error)
      })
    }
    const confirmDelete2 = () => {
      isLoading.value = true
      axios
      .delete(`comboard-attachment/${attachId.value.id}`)
      .then(response => {
        deleteDocComboard(response.data.data)

        isLoading.value = false
        refresh2()

        deleteModal2.value = false
        toast.success(response.data.message, { timeout: 5000 })
      }).catch(error => {
        isLoading.value = false
        console.log(error)
      })
    }
    const comboards = reactive({
      id: '',
      show_date: '',
      comboard_category_id: '',
      info: '',
      is_event: '',
      datetime_1: '',
      datetime_2: '',
      to_parent: '',
      to_teacher: '',
      to_student: '',
      add_to_calendar: '',
      is_recalled: '',
      recall_time: '',
      reason: '',
      created_by: '',
      updated_by: '',
      link_url: '',
      show_id: '',
      title: ''
    })
    const comboardsdetail2 = reactive({
      id: '',
      comboard_id: '',
      parent_comment_id: '',
      comment: '',
      created_by: '',
      updated_by: ''
    })
    const reload = 0
    const reset = () => {
      comboardsdetail.comment = ''
    }
    const comboardsdetail = reactive({
      id: '',
      comboard_id: '',
      parent_comment_id: '',
      comment: '',
      created_by: '',
      updated_by: ''
    })
    const defaultColDef = {
      resizeable: true
    }
    const columnDefs = [
      {
        headerName: '#',
        valueGetter: 'node.rowIndex+1',
        width: 60
      },
      // MENAMPILKAN DATA TANPA DOC MANAGEMENT
      {
        field: 'file_1',
        headerName: t('attachment.title_file1'),
        sortable: true,
        filter: true,
        minWidth: 400
      },
      // {
      //   field: 'file_name' || 'file_1',
      //   headerName: t('attachment.title_file1'),
      //   sortable: true,
      //   filter: true,
      //   minWidth: 400
      // },
      {
        field: 'id',
        headerName: t('main.action'),
        sortable: true,
        filter: true,
        minWidth: 190,
        cellRendererFramework: 'ButtonActionComboardAttachment'
      }
    ]
    const comboard = reactive({
                id: comboards.id,
                title: comboards.title,
                description: comboards.description,
                tumbnail: '',
                name: '',
                image1: '',
                image2: '',
                image3: '',
                imageDoc: '',
                event_date: '',
                event_end_date: '',
                created_by: '',
                updated_by: '',
                created_at: '',
                updated_at: ''
            })

    const refresh = async () => {
      isLoading.value = true
      await axios
      .get('comboard-detail', {
        params: {
          comboard_id: idValue.value
        }
      })
        .then(response => {
          comboardsdetail.value = response.data.data
          isLoading.value = false
        })
        .catch(error => {
          toast.error(error.response.data, { timeout: 5000 })
          console.log(error)
          isLoading.value = false
        })
    }
    onMounted(() => {
      // refresh()
    })

    const getImage = ref([])
    const getImg = async () => {
        isLoading.value = true

        const method = 'GET'
        const url = 'fileExist-comboard'
        const params = comboard
        axiosDocument({
            method,
            url,
            params
        })
        .then(response => {
            rowData.value = response.data.data
            isLoading.value = false
        })
        .catch(error => {
            isLoading.value = false
            console.log(error)
        })
    }
    const refresh2 = async () => {
      isLoading.value = true
      await axios
      .get('comboard-attachment', {
        params: {
          comboard_id: idValueAttach.value
        }
      })
      .then(response => {
        rowData.value = response.data.data
        slides.length = 0
        rowData.value.forEach(function (data) {
          slides.push(data.file_1)
        })
        // getImg()
        emit('click-refresh')
        isLoading.value = false
      })
      .catch((error) => {
        // toast.error(error.data.message)
        // getImg()
        // isLoading.value = false
      })
    }
    //  onMounted(() => { refresh2() })

    const store = async () => {
      const url = props.showEdit ? 'comboard-detail/' + comboardsdetail.id : 'comboard-detail'
      const method = props.showEdit ? 'PUT' : 'POST'
      if (method === 'POST') {
        comboardsdetail.created_by = userlogin
        } else {
          comboardsdetail.updated_by = userlogin
      }
      comboardsdetail.comboard_id = comboardsdetail2.comboard_id
      await axios({
        method,
        url,
        params: comboardsdetail
        })
        .then(response => {
          if (response.data.success) {
            toast.success(response.data.message)
            reset()
            refresh()
          } else {
            errors.value = response.data.messages
            toast.error(response.data.messages)
          }
      })
      .catch(error => {
        if (error.response) {
          console.log(error)
          toast.error(error.response.message)
          console.log(JSON.stringify(error.request))
        } else if (error.message) {
          console.log(error.message)
          toast.error(error.message)
          console.log(JSON.stringify(error.message))
        }
      })
    }
    const detailReplaceView = ref(false)
    const viewUpload = () => {
        detailReplaceView.value = true

        uploadFile.type = uploadFile.name
        if (uploadFile.name.includes('pdf')) {
            uploadFile.type = 'pdf'
        }else{
            uploadFile.type = 'img'
        }
    }

    const replaceModalView = ref(false)
    const replaceDataView = (env) => {
        resetView()

        replaceModalView.value = true
        uploadFile.id_file = env
    }
    const uploadFile = reactive({
        id_file: '',
        type: '',
        name: '',
        status: '',
        base64: '',
        title: '',
        created_by: userlogin
    })
    const resetView = () => {
        document.getElementById('my-file-comboard-replace').value = null

        // previewpdf.view = ''
        // previewpdf.type = ''

        uploadFile.id_file = ''
        uploadFile.type = ''
        uploadFile.name = ''
        uploadFile.base64 = ''
    }

    const preview = ref('')
    const onFileChange = (event) => {
        const resetPreview = () => {
            file.value = ''
        }
        const file = event.target.files[0]
        if (file.size > 5024 * 5024) {
            alert('File too big (> 5MB)')
            file.value = ''
            preview.value = ''

            document.getElementById('my-file-comboard-replace').value = null
        } else {
            const reader = new FileReader()

            reader.readAsDataURL(file)
            reader.onloadend = function () {
                preview.value = reader.result
                uploadFile.base64 = preview.value
                uploadFile.name = file.name
                uploadFile.title = comboard.title
            }
        }
        resetPreview()
    }

    const saveUpload = (env) => {
        let text = "Are you sure?"
        if(env == 'replace') {
            text = "You won't be able to access the old file. Are you sure?"
        }

        if (confirm(text) == true) {
            replaceComboardDoc(env)
        }
    }

    const replaceComboardDoc = (env) => {
        isLoading.value = true

        uploadFile.status = env
        uploadFile.user_id = comboard.id
        uploadFile.fullname = comboard.name
        uploadFile.title = comboard.title

        const jsonData = JSON.stringify(uploadFile)

        const configHeaders = {
            'content-type': 'application/json',
            Accept: 'application/json'
        }

        const url = 'replace-file-comboard'
        const method = 'POST'

        axiosDocument({
            method,
            url,
            data: jsonData,
            headers: configHeaders
        })
        .then(response => {
            getImg()
            resetView()
            refresh()
            getFile()
            replaceModalView.value = false
            // detailModalView.value = false

            isLoading.value = false
            toast.success(response.data.message)
        })
        .catch(error => {
            isLoading.value = false
            console.log('error', error)
        })
    }

    onBeforeMount(() => {})
    watch(() => idValue.value, (newVal, oldVal) => {
      refresh()
    })
    watch(() => idValueAttach.value, (newVal, oldVal) => {
      refresh2()
    })

    watchEffect(() => {
      const newComboardsdetail = props.propClass
      Object.assign(comboardsdetail2, newComboardsdetail)

      const id = newComboardsdetail.comboard_id
      idValue.value = id

      const idImage = newComboardsdetail.comboard_id
      idValueAttach.value = idImage

      const newComboards = props.propClass
      Object.assign(comboards, newComboards)
      Object.assign(comboard, newComboards)

    })

      return {
        showEditAtt,
        refreshHeader,
        mdiPlusCircleOutline,
        mdiBallot,
        mdiClose,
        mdiSend,
        mdiBookshelf,
        t,
        isLoading,
        attachmentModal,
        attachObject,
        detailModal,
        reload,
        columnDefs,
        defaultColDef,
        mdiCheckBold,
        mdiReload,
        mdiFileEyeOutline,
        mdiMenuDown,
        mdiCircleMedium,
        mdiTrashCan,
        titleStack,
        rowData,
        slides,
        comboards,
        comboard,
        recipientsModal,
        recipientsObject,
        comboardsdetail,
        comboardsdetailId,
        comboardsdetail2,
        childModal,
        childObject,
        store,
        reset,
        confirmDel,
        confirm2,
        cancel,
        cancel2,
        detailData,
        editData,
        hideModal,
        hideModal2,
        hideModalDetail,
        hideModal3,
        hideModal4,
        addAttachment,
        addChild,
        addRecipients,
        deleteComboard,
        deleteModalShow,
        deleteModal,
        deleteModal2,
        userlogin,
        errors,
        str,
        toast,
        router,
        activeTab,
        getImage,
        getImg,
        detailReplaceView,
        viewUpload,
        replaceModalView,
        replaceDataView,
        uploadFile,
        resetView,
        preview,
        onFileChange,
        saveUpload,
        replaceComboardDoc,
        tabs: [{
              index: 0,
              name: 'Comboard Detail'
              },
              {
              index: 1,
              name: 'Attachment Detail'
            }
          ]
      }
  },
  methods: {
  clearForm () {
    this.attachment = reactive({
      id: '',
      comboard_id: '',
      file_1: '',
      created_at: '',
      created_by: '',
      updated_at: '',
      updated_by: ''
    })
  }
},
  beforeMount () {
  this.context = {
    componentParent: this
  }
}
}
</script>
<style scoped>
li{
  list-style: none;
  border: 0px solid rgba(0, 0, 0, 0.25);
  padding: 1rem;
  border-radius: 0px;
  margin: 0px 35px 10px 15px;
  max-width: 100%;
}
input{
  width: 100%;
  border-bottom: 3px solid rgba(0, 0, 0, 0.25) !important;
  padding: 1rem 3rem 1rem 1rem ;
  margin-bottom: .25rem;
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  border-radius: 0px;
}
label{
  font-size: 12px;
  }

</style>
